export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mb-8">
            有影片推荐、片源建议或观影问题？欢迎与我们取得联系
          </p>

          <div className="bg-background-200/60 rounded-lg p-6 md:p-8 border border-background-300/30">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-500/10 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-200 mb-1">投稿邮箱</h3>
                <p className="text-xs text-foreground-500 break-all">film@xingkongmovie.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-500/10 flex items-center justify-center">
                  <i className="ri-message-3-line text-accent-500 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-200 mb-1">在线反馈</h3>
                <p className="text-xs text-foreground-500">工作日24小时内回复</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-500/10 flex items-center justify-center">
                  <i className="ri-team-line text-secondary-400 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-200 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500 break-all">biz@xingkongmovie.com</p>
              </div>
            </div>
            <a
              href="mailto:film@xingkongmovie.com"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-lg transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-send-plane-line text-sm"></i>
              </span>
              发送邮件咨询
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}